import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Row, Col } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'
import moment from 'moment'

let chartData = null

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			graphData: []
		}

		this.handleChartData = this.handleChartData.bind(this)
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (_.has(nextProps.dashboardData, 'graphData')) {
		  return ({ graphData: nextProps.dashboardData.graphData }) // <- this is setState equivalent
		}
		return null
	  }

	handleChartData (graphData) {
		console.log('graphData', graphData)
		const options = {
			chart: {
				height: 300,
				type: 'bar',
				toolbar: {
					show: !1
				}
			},
			plotOptions: {
				bar: {
					columnWidth: '14%',
					endingShape: 'rounded'
				}
			},
			dataLabels: {
				enabled: !1
			},
			series: [{
				name: 'Visitors',
				// data: [42, 56, 200, 64, 26, 42, 56]
				data: graphData
			}],
			grid: {
				yaxis: {
					lines: {
						show: !1
					}
				}
			},
			xaxis: {
				labels: {
					rotate: -90
				},
				categories: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
			},
			colors: ['#e74c5e'],
			fill: {
				type: 'gradient',
				gradient: {
					shade: 'dark',
					type: 'vertical',
					shadeIntensity: 1,
					gradientToColors: ['#4090cb'],
					inverseColors: !0,
					opacityFrom: .85,
					opacityTo: .85,
					stops: [0, 100, 100, 100]
				}
			}
		}
		chartData = new window.ApexCharts(document.querySelector('#chart-visitors'), options).render()
		if (!chartData) {
			chartData.render()
		}
	}
    
	render() {
		const { graphData } = this.state
		const { dashboardData } = this.props

		this.handleChartData(graphData)
		return (
			<React.Fragment>
				<div className="card-body">
					<h4 className="card-title mb-4">{moment().startOf('week').format('LL')} to {moment().endOf('week').format('LL')}</h4>
					
					<div id="chart-visitors" className="apex-charts" dir="ltr"></div>
				</div>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
